import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FieldErrorDisplayComponent } from './field-error-display.component';

@NgModule({
    imports: [CommonModule, MatFormFieldModule, TranslateModule, FieldErrorDisplayComponent],
    exports: [FieldErrorDisplayComponent],
})
export class FieldErrorDisplayModule {}
